import { render, staticRenderFns } from "./ChatsLists.vue?vue&type=template&id=248281f3"
import script from "./ChatsLists.vue?vue&type=script&lang=js"
export * from "./ChatsLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports